export const gfrDetailsDefaultGroupingFields = ['sectornm']
export const gfrDetailsDateFilterFields = ['maturity_date']
export const gfrSecurityDetailsDefaultColumnsFieldsToVisible = [
  'security_id',
  'description',
  'coupon',
  'maturity_date',
  'notional_weight',
  'predicted_beta',
  'security_risk',
  'model_risk',
  'specific_risk',
  'fi_d1_risk_contrib',
  'fi_term_structure_risk_contrib',
  'fi_sector_risk_contrib',
  'fi_quality_risk_contrib',
  'fi_other_risk_contrib',
  'model_risk_contrib',
  'currency_risk_contrib',
  'specific_risk_contrib',
  'security_risk_contrib',
]

export const gfrSecurityDetailsTopAndBottom5FieldsToVisible = [
  'security_id',
  'security_risk_contrib',
  'description',
  'holdings',
  'security_risk',
  'notional_weight',
]
export const gfrColumnFieldForTableChartLinkingValue = ['notional_weight']
export const gfrTopAndBottomFiveSecuritiesFilterKey = 'security_risk_contrib'
export const gfrSecurityDetailsFieldsToAggregate = [
  'security_risk_contrib',
  'notional_weight',
  'fi_d1_risk_contrib',
  'fi_term_structure_risk_contrib',
  'fi_sector_risk_contrib',
  'fi_quality_risk_contrib',
  'fi_other_risk_contrib',
  'model_risk_contrib',
  'currency_risk_contrib',
  'specific_risk_contrib',
]
